const Constants = {
 serverlink:'https://apix.freshvery.com/',
  mediaserverlink:'https://media.freshvery.com/',
//serverlink: 'http://localhost:3001/',
//mediaserverlink:'http://localhost:3020',
    timeout: 400000000
};

export default Constants;
